import React, { useEffect, useRef, useState } from "react";
import { coordenadas } from '../../store/actions/coordenadas'
import { useDispatch, useSelector } from 'react-redux'
import { meteorologicoNodo } from '../../store/actions/meteorologicoNodo'
import { sueloNodo } from '../../store/actions/sueloNodo'
import { riegoNodo } from '../../store/actions/riegoNodo'
import { entornoNodo } from '../../store/actions/entornoNodo'
import { aguaSaladaNodo } from '../../store/actions/aguaSaladaNodo'
import { aguaDulceNodo } from '../../store/actions/aguaDulceNodo'
import { teslaNodo } from '../../store/actions/teslaNodo'
import "mapbox-gl/dist/mapbox-gl.css";
import { Link } from 'react-router-dom';
import 'leaflet/dist/leaflet.css';
import 'leaflet-fullscreen/dist/leaflet.fullscreen.css';
import 'leaflet-fullscreen/dist/Leaflet.fullscreen.js';
import '../home/map.css';
import '../home/styles.css';
import '../home/datosSensor.css';
import mapboxgl from 'mapbox-gl/dist/mapbox-gl-csp';
import 'mapbox-gl/dist/mapbox-gl.css';

// Use the CSP-compatible worker without worker-loader (works in Webpack 5 / CRA v5)
mapboxgl.workerClass = class {
    constructor() {
        return new Worker(
            new URL('mapbox-gl/dist/mapbox-gl-csp-worker.js', import.meta.url),
            { type: 'module' }
        );
    }
};


// Función para obtener la URL de Grafana
const getGrafanaUrl = (item2) => {
    var id = 0;
    switch (item2) {
        case 'meteorologico':
            id = 4;
            break;
        case 'suelo':
            id = 6
            break;
        case 'salada':
            id = 2;
            break;
        case 'riego':
            id = 5;
            break;
        case 'entorno':
            id = 3;
            break;
        case 'dulce':
            id = 1;
            break;
        case 'tesla':
            id = 7;
            break;
        default:
            id = 0;
            break
    }
    const grafanaBase = "/d/";
    const dashboardUrls = {
        1: "fedgbzpsr0gsgb/dulce-mapa?orgId=1&from=now-6h&to=now&timezone=browser",
        2: "eedjjj7l2uygwb/salada-mapa?orgId=1&from=2024-10-01T16:37:19.000Z&to=2024-10-23T09:19:51.000Z&timezone=browser",
        3: "cedggmhwhqf40e/entorno-mapa?orgId=1&from=2024-10-01T16:37:19.000Z&to=2024-11-07T11:42:12.000Z&timezone=browser",
        4: "fedgit6rlohkwa/metorologico-mapa?orgId=1&from=2024-10-01T16:37:19.000Z&to=2024-10-22T16:22:34.000Z&timezone=browser",
        5: "dedgk9ebooao0c/riego-mapa?orgId=1&from=2024-10-01T16:37:19.000Z&to=2024-11-07T11:14:48.000Z&timezone=browser",
        6: "dedjj28lfgxdse/suelo-mapa?orgId=1&from=2024-10-01T16:37:19.000Z&to=2024-11-07T11:00:14.000Z&timezone=browser"
    };

    if (dashboardUrls[id]) {
        return `${grafanaBase}${dashboardUrls[id]}?orgId=1&from=2024-10-01T18:37:19.000Z&to=2024-12-11T16:21:55.000Z&timezone=browser&theme=light&kiosk`;
    }

    return grafanaBase;
};

const Map3D = () => {

    const mapContainer = useRef(null);
    const map = useRef(null);
    const [isLoading, setIsLoading] = useState(true);
    const dispatch = useDispatch();
    const [isLoadingResultados, setIsLoadingResultados] = useState(false);
    const Coordenadas = useSelector(state => state.coordenadas);
    const [resultadosMeteorologicos, setResultadosMeteorologicos] = useState([]);


    useEffect(() => {
        if (isLoading) {
            setIsLoading(true);
            dispatch(coordenadas(Coordenadas)).finally(() => {
                setIsLoading(false);
                setIsLoadingResultados(true);
            });
        }
    }, [Coordenadas, isLoading]);

    useEffect(() => {
        const eliminarDuplicados = (lista) => {
            const seen = new Set();
            const uniqueList = [];

            lista.forEach(item => {
                // Filtrar para eliminar elementos con item1 vacío
                if (item.item1.length === 0) return;

                // Convertir item1 en una clave única ordenada
                const item1Key = item.item1
                    .map(obj => `${obj.lat},${obj.lon}`)
                    .sort()
                    .join('|');

                // Crear clave única combinando item1 y item2
                const coordKey = `${item1Key}|${item.item2}`;

                if (!seen.has(coordKey)) {
                    seen.add(coordKey);
                    uniqueList.push(item);
                }
            });

            return uniqueList;
        };



        const fetchMeteorologico = async () => {
            if (isLoadingResultados) {
                try {
                    const resultadosTemporales = []; // Almacenar resultados temporalmente

                    const promises = Coordenadas.current.map(async (coord) => {
                        const { lat, lon } = coord;
                        try {
                            const tipos = [
                                teslaNodo,
                                meteorologicoNodo,
                                sueloNodo,
                                riegoNodo,
                                entornoNodo,
                                aguaSaladaNodo,
                                aguaDulceNodo,
                            ];

                            for (const accion of tipos) {
                                const res = await dispatch(accion({ lat, lon }));
                                if (res.payload && res.payload[0] != null) {
                                    // Agregar un objeto con `item1` y `item2` si existen
                                    resultadosTemporales.push({
                                        item1: res.payload[0],
                                        item2: res.payload[1] || null
                                    });
                                }
                            }
                        } catch (error) {
                            console.error(`Error al obtener datos para ${lat}, ${lon}:`, error);
                        }
                    });

                    await Promise.all(promises);
                    // Eliminamos duplicados y actualizamos el estado
                    const listaSinDuplicados = eliminarDuplicados(resultadosTemporales);
                    setResultadosMeteorologicos(listaSinDuplicados);
                } finally {
                    setIsLoading(false);
                    setIsLoadingResultados(false);
                }
            }
        };
        fetchMeteorologico();
    }, [isLoadingResultados, Coordenadas]);

    useEffect(() => {
        mapboxgl.accessToken = "pk.eyJ1IjoibWF0dXB2IiwiYSI6ImNtMWhxYXVqYzBpcXAybHFsYm5yNnE3ZmMifQ.MrjouJnOqqGGLKM4k9aphw";

        if (map.current) return; // Evitar reinicializar el mapa

        map.current = new mapboxgl.Map({
            container: mapContainer.current,
            style: "mapbox://styles/mapbox/satellite-streets-v12", // Estilo con terreno
            center: [-0.229812, 38.985349], // Gandia
            zoom: 6,
            pitch: 60, // Inclinación 3D
            bearing: -20, // Rotación
            antialias: true // Suaviza bordes en 3D
        });

        map.current.on("load", () => {
            // Agregar la fuente de elevación
            map.current.addSource("mapbox-dem", {
                type: "raster-dem",
                url: "mapbox://mapbox.terrain-rgb",
                tileSize: 512,
                maxzoom: 14
            });

            // Aplicar terreno 3D
            map.current.setTerrain({ source: "mapbox-dem", exaggeration: 1.5 });

            // Agregar controles de navegación
            map.current.addControl(new mapboxgl.NavigationControl(), "top-right");
            map.current.addControl(new mapboxgl.FullscreenControl());

            // Añadir efecto de niebla para mejor visualización 3D
            map.current.setFog({
                range: [0.5, 10],
                color: "rgba(186, 210, 235, 0.5)",
                "horizon-blend": 0.2
            });
        });

        return () => map.current.remove();
    }, []);
    // Función para actualizar los puntos en el mapa
    const updateGeoJSON = () => {
        const geojson = {
            type: "FeatureCollection",
            features: resultadosMeteorologicos.map((element) => ({
                type: "Feature",
                id: element.id,
                geometry: {
                    type: "Point",
                    coordinates: [parseFloat(element.item1[0].lon), parseFloat(element.item1[0].lat)]
                },
                properties: {
                    id: element.item2,
                    name: "Nodo multiparamétrico"
                }
            }))
        };
        if (map.current) {
            map.current.on("load", () => {
                if (map.current.getSource("points")) {
                    map.current.getSource("points").setData(geojson);
                }
                else {
                    map.current.addSource("points", { type: "geojson", data: geojson });

                    map.current.addLayer({
                        id: "points",
                        type: "circle",
                        source: "points",
                        paint: {
                            "circle-color": "#4264fb",
                            "circle-radius": 8,
                            "circle-stroke-width": 2,
                            "circle-stroke-color": "#ffffff"
                        }
                    });

                    const mapWidth = map.clientWidth;
                    const mapHeight = map.clientHeight;

                    const popupWidth = mapWidth; // 60% del ancho del mapa
                    const popupHeight = mapHeight; // 60% del alto del mapa

                    // Eventos de interacción con los puntos
                    map.current.on("click", "points", (e) => {
                        const clickedFeature = e.features[0];
                        const grafanaUrl = getGrafanaUrl(clickedFeature.properties.id);

                        new mapboxgl.Popup({ maxWidth: "none" })
                            .setLngLat(clickedFeature.geometry.coordinates)
                            .setHTML(`

                            <div style="width: 60vh; height: 60vh;">
                                <h3>Nodo multiparamétrico</h3>
                                <iframe src="${grafanaUrl}" width="100%" height="90%" frameborder="0"></iframe>
                            </div>
                    `)
                            .addTo(map.current);
                    });

                    map.current.on("mouseenter", "points", () => {
                        map.current.getCanvas().style.cursor = "pointer";
                    });

                    map.current.on("mouseleave", "points", () => {
                        map.current.getCanvas().style.cursor = "";
                    });
                }
            });
        }
    };

    updateGeoJSON();

    return (
        <>
            <nav class="sb-topnav navbar navbar-expand navbar-dark bg-dark">
                <a class="navbar-brand ps-3" href="index.html">Multiparametric sensor</a>
                <form class="d-none d-md-inline-block form-inline ms-auto me-0 me-md-3 my-2 my-md-0">
                </form>
            </nav>
            <div id="layoutSidenav">
                <div id="layoutSidenav_nav">
                    <nav class="sb-sidenav accordion sb-sidenav-dark" id="sidenavAccordion">
                        <div class="sb-sidenav-menu">
                        </div>
                        <div class="sb-sidenav-footer">
                            <div class="small">MADE BY:</div>
                            miguelzaragozaesquerdo
                            @gmail.com
                        </div>
                    </nav>
                </div>
                <div id="layoutSidenav_content" class="flex-grow-1">
                    <div
                        ref={mapContainer}
                        style={{ width: "100%", height: "100%", position: "relative" }}
                    />
                </div>
                <div id="layoutSidenav_nav">
                    <nav className="sb-sidenav accordion sb-sidenav-dark" id="sidenavAccordion">
                        <div className="sb-sidenav-menu">
                            <div className="nav">
                                <div className="sb-sidenav-menu-heading" id="titulo">Options</div>
                                <Link id="link" to="/">
                                    <button type="button" id="link" className={`btn btn-light`}>
                                        <div className="sb-nav-link-icon">
                                            <i className="fas fa-tachometer-alt"></i>
                                        </div>
                                        Back
                                    </button>
                                </Link>
                            </div>
                        </div>
                        <div className="sb-sidenav-footer">
                            <div className="small">MADE BY:</div>
                            miguelzaragozaesquerdo
                            @gmail.com
                        </div>
                    </nav>
                </div>
            </div>
        </>

    );
};

export default Map3D;